export class GeoObj {
  geo_id: string;
  name: string;
}

export class GeoObjCityReg {
  geo_id: string;
  name: string;
  bid_factor: number;
  country_name: string;
  region_name: string;
  constructor() {
    this.bid_factor = 1.00;
    this.country_name = '';
    this.region_name = '';
  }
}
export class RegionObject {
  region: any;
  region_included: boolean;
  cities: Array<GeoObjCityReg>;
  bid_factor: number;

  constructor() {
    this.cities = [];
    this.region_included = true;
    this.bid_factor = 1.00;
  }
}

export class CountryObject {
  // level: 'high' | 'medium' | 'low' | 'zero'
  country: GeoObj;
  country_included: boolean;
  regions: Array<RegionObject>;
  bid_factor: number;

  constructor() {
    // this.level = 'medium';
    this.regions = [];
    this.country_included = true;
    this.bid_factor = 1.00;
  }
}

export class GeoObject {
  geo_id: string;
  bid_factor: number;
  name: string;
}

export class Geography {
  region_action: string;
  // metro_action: string;
  city_action: string;
  country_action: string;
  zip_action: string;

  country: Array<any>;
  city: Array<any>;
  region: Array<any>;
  postal_code: Array<any>;
  // zip: Array<any>;
  // metro: Array<any>;

  constructor() {
    this.country = [];
    this.city = [];
    this.region = [];
    this.postal_code = [];
    //     this.zip = [];
    //     this.metro = [];

        this.region_action = "";
    //     this.metro_action = "";
        this.city_action = "";
        this.country_action = "";
        this.zip_action = "include";
  }
}

export class contexual{
  predefined: Array<any>;
  demographic: Array<any>;
  constructor(){
    this.predefined = [];
    this.demographic = [];
  }
}

export class Platform {
  device_type: Array<any>;
  device_type_action: string;
  operating_system: Array<any>;
  operating_system_action: string;

  constructor() {
    this.device_type = ["desktop", "mobile", "tablet"];
    this.device_type_action = "include";
    this.operating_system = [];
    this.operating_system_action = "include";
  }
}

export class BrandSafety {
  adult_content: number;
  alcohol_content: number;
  drug_content: number;
  gambling_content: number;
  hate_speech_content: number;
  illegal_download_content: number;
  offensive_language_content: number;
  violent_content: number;

  constructor() {
    this.adult_content = 2;
    this.alcohol_content = 2;
    this.drug_content = 2;
    this.gambling_content = 2;
    this.hate_speech_content = 2;
    this.illegal_download_content = 2;
    this.offensive_language_content = 2;
    this.violent_content = 2;
  }
}

export class TdspTargeting {
  geo: Geography;
  geo_optimization: boolean;
  weather_list: Array<any>;
  device_optimization: boolean;
  inventory_types: string;
  inventory_optimization: boolean;
  audience_booster: boolean;
  exclude_households: boolean;
  target_trackable_users: boolean;
  audience: Array<any>;
  min_temp: number;
  max_temp: number;
  platform: Platform;
  device_types: Array<any>;
  day_parting: Object;
  koa_audience: boolean;
  premium_inventory: boolean;
  domain_optimization: boolean;
  target_everyone: boolean;
  domains: Array<any>;
  domains_action: string;
  inventory_lists: Array<any>;
  custom_location: Array<any>;
  selected_audience: string;
  app_categories: Array<any>;
  web_categories: Array<any>;
  custom_context_cats: Array<any>;
  contextual_categories: contexual;
  brand_safety: BrandSafety;
  deals: Array<any>;
  is_brand_safety_enabled: boolean;
  ad_formats: Array<any>;
  ad_format_optimization: boolean;

  // contextual_categories: Array<any>

  constructor() {
    this.geo = new Geography();
    this.contextual_categories = new contexual();
    this.geo_optimization = false;
    this.device_optimization = false;
    this.domain_optimization = false;
    // this.platform = new Platform();
    this.inventory_optimization = false;
    this.koa_audience = false;
    this.audience = [];
    this.inventory_types = 'app';
    this.weather_list = [];
    this.exclude_households = false;
    this.audience_booster = false;
    this.target_trackable_users = false;
    this.is_brand_safety_enabled = true;
    this.device_types = [
      {
          "type": "pc",
          "bid_factor": "1.00"
      },
      {
          "type": "tv",
          "bid_factor": "1.00"
      },
      {
          "type": "mobile",
          "bid_factor": "1.00"
      },
      {
          "type": "tablet",
          "bid_factor": "1.00"
      }
    ];
    this.deals = []
    this.premium_inventory = false;
    this.target_everyone = false;
    this.domains = [];
    this.domains_action = 'include';
    this.inventory_lists = [];
    this.selected_audience = 'custom';
    this.custom_location = [];
    this.app_categories = [];
    this.web_categories = [];
    this.custom_context_cats = [];
    this.brand_safety = new BrandSafety();
    this.ad_formats = [];
    this.ad_format_optimization = false;
  }
}

export let ioDealTypeMapping: { [key: string]: string } = {
  pmp: "PMP Deal",
  open_rtb: "Open RTB",
};

export class LIAssoc {
  creatives: Array<any>;
  ad_formats: Array<any>;
  ad_format_optimization: boolean;

  constructor() {
    this.creatives = [];
    this.ad_formats = [];
    this.ad_format_optimization = false;
  }
}

export class KpiObject {
  goal_type: string;
  value: any;
  constructor() {
  }
}

export class TdspFlight {
  flight: number;
  budget: number;
  daily_budget: number;

  constructor() { }
}

export class TdspLineItem {
  name: string;
  state: "active" | "inactive";
  is_dco_creatives: boolean;
  ad_type: string;
  kpi: any;
  predictive_clearing: boolean;
  targeting: TdspTargeting;
  frequency_caps: Array<TdspFrequencyCap>;
  min_cpm: number;
  max_cpm: number;
  creatives: Array<any>;
  flights: Array<TdspFlight>;
  is_dco_li: boolean;

  constructor() {
    this.name = "";
    this.state = "inactive";
    // Todo remove static setting
    this.is_dco_creatives = false;
    this.ad_type = "banner";
    this.kpi = {};
    this.predictive_clearing = false;
    this.targeting = new TdspTargeting();
    this.frequency_caps = [];
    this.creatives = [];
    this.is_dco_li = false;
  }
}

export class TdspFrequencyCap {
  interval: "day" | "hour" | "week";
  duration: number;
  imps: number;

  constructor() {
    this.interval = "day";
    this.duration = 1;
    this.imps = 6;
  }
}

export interface City {
  id: number;
  name: string;
  level: 'low' | 'medium' | 'high';
  bid_factor?: number;
}

export interface Region {
  region: { id: number; name: string };
  level: 'low' | 'medium' | 'high';
  region_included: boolean;
  bid_factor?: number;
  cities: City[];
}

export interface CountryObjectInterface {
  country: { id?: number; name: string };
  level: 'low' | 'medium' | 'high';
  country_included: boolean;
  bid_factor?: number;
  regions: Region[];
}

// optimize this function
export function buildTdspLineItem(event: any, selectedIo: any, lIAssoc: any, liFlight: any) {
  const tdspLineItem = event.tdspLineItem;
  const tdspTargeting = event.targeting;
  const geoObject = event.geoObject;
  const week = event.week;

  tdspLineItem.targeting.koa_audience = tdspTargeting.selected_audience == 'koa';
  tdspLineItem.targeting.target_everyone = tdspTargeting.selected_audience == 'everyone';

  if(!tdspLineItem.is_dco_li) {
    if (tdspTargeting.selected_audience == 'custom')
      tdspLineItem.targeting.audience = tdspTargeting.audience?.length ? tdspTargeting.audience[0].id : null;
    if (tdspTargeting.selected_audience != 'custom') {
      delete tdspLineItem.targeting.audience;
    }
  }
  else{
  console.log(tdspLineItem.targeting.audience);
    tdspLineItem.targeting.audience = tdspTargeting.audience;
  }
  console.log(tdspLineItem.targeting.audience);

  tdspLineItem.targeting.weather_list = event.selectedWeather;
  tdspLineItem.targeting.max_temp = event.temperatureMax;
  tdspLineItem.targeting.min_temp = event.temperatureMin;
  tdspLineItem.targeting.geo_optimization = event.geoOptimization;
  tdspLineItem.targeting.device_optimization = tdspTargeting.device_optimization;
  tdspLineItem.targeting.inventory_optimization = tdspTargeting.inventory_optimization;
  tdspLineItem.targeting.premium_inventory = tdspTargeting.premium_inventory;
  tdspLineItem.targeting.audience_booster = event.targeting.audience_booster;
  tdspLineItem.targeting.geo.zip_action = event.zip_action;
  if (
    tdspTargeting.selected_audience !== 'custom' ||
    ![tdspLineItem.kpi]?.some(k => k.goal_type === 'cpa' || k.goal_type === 'roas')
  ) {
    tdspLineItem.targeting.audience_booster = false;
  }
  tdspLineItem.targeting.exclude_households = event.targeting.exclude_households;
  tdspLineItem.targeting.target_trackable_users = tdspTargeting.selected_audience == 'everyone' ? event.targeting.target_trackable_users : false;
  tdspLineItem.targeting.inventory_types = tdspTargeting.inventory_types;
  tdspLineItem.creatives = lIAssoc.creatives.map((creative: any) => creative.id);
  tdspLineItem.targeting.inventory_lists = event.targeting.inventory_lists ? event.targeting.inventory_lists.map((inventory: any) => inventory.id) : [];
  tdspLineItem.targeting.custom_location = event.customLocs?.length
  ? Number(event.customLocs[0].id)
  : null;
  tdspLineItem.targeting.deals = event.deals.map((ele)=>ele.id)
  // Build day_parting
  const outputDayPart: Record<string, number[]> = {};
  let hasAnyHours = false;

  for (const [day, hours] of Object.entries(week)) {
    const arr = Array(24).fill(0);

    (hours as number[]).forEach((h) => {
      if (h >= 0 && h < 24) {
        arr[h] = 1;
        hasAnyHours = true; // Found at least one active hour
      }
    });

    outputDayPart[day] = arr;
  }

  // If no hours selected across all days, set empty object
  tdspLineItem.targeting.day_parting = hasAnyHours ? outputDayPart : {};

  // Device types
  tdspLineItem.targeting.device_types = tdspTargeting.device_types;
  if(tdspLineItem.ad_type == "connected_tv") {
    tdspLineItem.targeting.device_types = tdspLineItem.targeting.device_types.filter(d => d.type == "tv");
  } else{
    tdspLineItem.targeting.device_types = tdspLineItem.targeting.device_types.filter(d => d.type != "tv");
  }

  tdspLineItem.targeting.geo.postal_code = event.tdspLineItem.targeting.geo.postal_code || [];
  if(!containsUnitedStates(event.targeting.geo)) {
    tdspLineItem.targeting.exclude_households = false;
  }
  tdspLineItem.targeting.geo = event.targeting.geo;
  geoObject.forEach((geo: any) => {
    if (geo.country_included) {
      const exists = tdspLineItem.targeting.geo.country.some(
        (c: any) => c.id === geo.country.id
      );
      if (!exists) {
        tdspLineItem.targeting.geo.country.push({
          geo_id: geo.country.id,
          name: geo.country.name,
          bid_factor: geo.bid_factor
        });
      }
    }

    geo.regions.forEach((reg: any) => {
      if (reg.region_included) {
        const exists = tdspLineItem.targeting.geo.region.some(
          (r: any) => r.id === reg.region.id
        );
        if (!exists) {
          tdspLineItem.targeting.geo.region.push({
            geo_id: reg.region.id,
            name: reg.region.name,
            bid_factor: reg.bid_factor,
            country_name: reg.region.country_name
          });
        }
      }
      reg.cities.forEach((city: any) => {
        const exists = tdspLineItem.targeting.geo.city.some(
          (c: any) => c.id === city.id
        );
        if (!exists) {
          tdspLineItem.targeting.geo.city.push({
            geo_id: city.id,
            name: city.name,
            bid_factor: city.bid_factor,
            region_name: reg.region.name,
            country_name: city.country_name
          });
        }
      });
    });
  });
  tdspLineItem.targeting.geo.postal_code_action = event.zip_action == 'include' ? 'target' : 'block';
  tdspLineItem.targeting.domains = event.validDomainAppurls;
  tdspLineItem.targeting.domains_action = tdspLineItem.targeting.domains_action == 'include' ? 'target' : 'block';

  // Flights
  if (!selectedIo.auto_allocate_budgets) {
    tdspLineItem.flights = (liFlight || []).map((flight: any) => {
      const tdspFlight = new TdspFlight();
      tdspFlight.flight = flight.id;
      tdspFlight.budget = flight.revenue_budget ? parseFloat(flight.revenue_budget) : 0;
      tdspFlight.daily_budget = flight.daily_revenue_budget ? parseFloat(flight.daily_revenue_budget) : 0;
      return tdspFlight;
    });
  } else {
    delete tdspLineItem.flights;
  }
  delete tdspLineItem.targeting.selected_audience;
  tdspLineItem.targeting.web_categories = tdspLineItem.targeting.web_categories.map((ele)=>ele.id)
  tdspLineItem.targeting.app_categories = tdspLineItem.targeting.app_categories.map((ele)=>ele.id)
  tdspLineItem.targeting.custom_context_cats =event.targeting.custom_context_cats.map((ele)=>ele.id)
  tdspLineItem.targeting.ad_formats = lIAssoc.ad_formats;
  tdspLineItem.targeting.ad_format_optimization = lIAssoc.ad_format_optimization
  return tdspLineItem;
}

export const goalTypeNameMap: Record<string, string> = {
  reach: "Reach",
  cpa: "CPA",
  cpc: "CPC",
  roas: "ROAS",
  ctr: "CTR",
  vcr: "Video Completion Rate",
  inc_reach: "Incremental reach",
  viewability: "Viewability"
};


export class isValid {
  li_basic_setup: boolean;
  li_creative: boolean;
  li_targeting: boolean;

  constructor() {
    this.li_basic_setup = true;
    this.li_creative = true;
    this.li_targeting = true;
  }
}

export function containsUnitedStates(geo: any): boolean {
  return geo.country.some(country => country.name.includes('United States')) ||
  geo.region.some(region => region.country_name.includes('United States')) ||
  geo.city.some(city => city.country_name.includes('United States'));
}

export const BidFactorTooltipMessage = `Bid factor is a way of telling “I want more impressions like this” by bid factoring over 1,
  and “I want fewer impressions like this” by bid factoring less than 1.

  Bid factors do two things. First, they signal to the platform your desire for more or less volume.
  Second, they signal to the platform that you’re willing to allocate more budget to those impressions either by increasing budget or bidding up or down to get that impression.

  Bid factor of 0 blocks delivery.

  Bid factors cannot be set if auto optimization is enabled for this targeting.`;

export const IvtListTooltipMsg = `You can create either a publisher or a domain list`;

export const deviceTypeOptions =  [
    { type: 'pc', label: 'Desktop & Laptop', icon: 'desktop_windows' },
    { type: 'tv', label: 'Connected TV', icon: 'connected_tv' },
    { type: 'mobile', label: 'Mobile', icon: 'phone_iphone' },
    { type: 'tablet', label: 'Tablet', icon: 'tablet' },
    // { type: 'dooh', label: 'Dooh', icon: 'dooh' }
];

export const environmentTypeOptions = ["app", "web", "app_and_web"];

export const inventoryCtgyOptions: Array<any> = [
    { 'label': 'App Category', 'value': 'app_category' },
    { 'label': 'Web Category', 'value': 'universal_category' },
];

export const segmentTypeOptions: Array<any> = [
  { 'label': 'Let me choose my Custom Audience', "value": 'custom', "tootip":"", "icon": null },
  { 'label': 'Let the Platform select highly relevant Audience for me', "value": 'koa', "tootip":"This feature automatically and dynamically builds audience to expand reach.Charges apply for data cost", "icon": 'auto_awesome' },
  { 'label': 'Target Everyone', "value": 'everyone', "tootip":"", "icon": null },
]

export interface bulkUploadCreatives {
  li_ids: Array<string>;
  add: Array<number>;
  remove: Array<number>;
}

export const bulkUploadCreativesPayload: bulkUploadCreatives = {
  li_ids: [],
  add: [],
  remove: []
}

export interface bulkUpdateBasicFields {
  kpi?: KpiObject;
  min_cpm?: number;
  max_cpm?: number;
}

export interface bulkUpdateBasicPayload {
  li_ids: Array<any>;
  edited_fields: bulkUpdateBasicFields;
}

export const liBulkBasicUpdatePayload: bulkUpdateBasicPayload = {
  li_ids: [],
  edited_fields: {
    kpi: {
      goal_type: '',
      value: null
    },
    min_cpm: null,
    max_cpm: null,
  }
};

export interface bulkUpdateTargetingFields {
  add: TdspTargeting;
  remove: TdspTargeting;
  remove_all: Array<any>;
}

export interface bulkUpdateTargetingPayload{
  li_ids: Array<any>;
  edited_fields: any;
}

export const liBulkTargetingUpdatePayload: bulkUpdateTargetingPayload = {
  li_ids: [],
  edited_fields: {
    add: {
      ...new TdspTargeting(),
      geo: {
        ...new Geography(),
        region_action: 'include',
        city_action: 'include',
        country_action: 'include',
        zip_action: 'include',
        postal_code_action: 'target',
      },
      device_types: [],
      min_temp: null,
      max_temp: null,
      day_parting: {},
    },
    remove: {
      ...new TdspTargeting(),
      geo: {
        ...new Geography(),
        region_action: '',
        city_action: '',
        country_action: '',
        zip_action: '',
        postal_code_action: '',
      },
      device_types: [],
      inventory_types: null,
      min_temp: null,
      max_temp: null,
      day_parting: {},
    },
    remove_all: []
  }
};

export const GamblingSubCtg = 'Casinos & Gambling';
